export type SupportedCountryCode = '+1' | '+91';

export const SUPPORTED_COUNTRIES: {
  code: SupportedCountryCode;
  label: string;
  flag: string;
  placeholder: string;
}[] = [
  { code: '+1', label: 'United States', flag: '🇺🇸', placeholder: '(555) 555-5555' },
  { code: '+91', label: 'India', flag: '🇮🇳', placeholder: '98765 43210' },
];

export const stripDigits = (v: string) => v.replace(/\D/g, '');

export function formatByCountry(digits: string, country: SupportedCountryCode): string {
  const d = digits.slice(0, 10);
  if (country === '+1') {
    if (d.length <= 3) return d;
    if (d.length <= 6) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  }
  return d.length <= 5 ? d : `${d.slice(0, 5)} ${d.slice(5)}`;
}

export function validateForCountry(digits: string, country: SupportedCountryCode): string | null {
  if (digits.length !== 10) return 'Enter a 10-digit phone number';
  if (country === '+1' && /^[01]/.test(digits)) return 'Invalid US area code';
  if (country === '+91' && !/^[6-9]/.test(digits)) {
    return 'Indian mobile numbers start with 6, 7, 8, or 9';
  }
  return null;
}

const REMOVE_FROM_EXISTING = /please remove it from your existing account first\.?/i;

export const clerkMessage = (err: { longMessage?: string; message?: string } | null | undefined) => {
  if (!err) return null;
  const base = err.longMessage || err.message;
  if (!base) return null;
  return base.replace(REMOVE_FROM_EXISTING, 'please contact us.');
};
